<script setup lang="ts">
  import { useLegalDocumentStore } from '@/stores/legal-document-store';

  const localePath = useLocalePath();

  const chatStore = useChatStore();

  const { getDocumentSlugForAlias } = useLegalDocumentStore();
</script>

<template>
  <div class="chat-terms modal-container">
    <div class="chat-terms-modal">
      <div class="chat-terms-modal__wrapper">
        <div class="chat-terms-modal__header">
          <div class="chat-terms-modal__title">{{ $t('chat.termsModal.title') }}</div>
          <a
            class="chat-terms-modal__close"
            @click.prevent.stop="chatStore.declineTerms" />
        </div>
        <div class="chat-terms-modal__content">
          <p>
            {{ $t('chat.termsModal.terms1') }}
            <NuxtLink
              :to="localePath({ name: 'documents-dslug', params: { dslug: getDocumentSlugForAlias('privacyPolicyChat') } })"
              class="text-magenta"
              target="_blank">
              {{ $t('chat.termsModal.termsLink') }}
            </NuxtLink>
            {{ $t('chat.termsModal.terms2') }}
          </p>
          <p>
            {{ $t('chat.termsModal.info') }}
          </p>
        </div>
        <div class="chat-terms-modal__footer">
          <button
            class="chat-terms-modal__btn-accept"
            @click.prevent.stop="chatStore.acceptTerms">
            {{ $t('chat.termsModal.accept') }}
          </button>
          <button
            class="chat-terms-modal__btn-decline"
            @click.prevent.stop="chatStore.declineTerms">
            {{ $t('chat.termsModal.decline') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
